//-----------------------------------
import axios from 'axios'

//-----------------------------------
const apiRoot = ct.url.combine(ct.pa.ModuleUrlFull, 'api/');
const appRoot = ct.pa.ModuleUrlFull;
//-----------------------------------
export default {

    file: {
        run(obj,fileName) {
            let formdata = new FormData();
            formdata.append('data', JSON.stringify(obj));
            return axios.post(appRoot + 'file', formdata, {
                responseType: "blob"
            })
                .then((res) => {
                    const blob = new Blob([res.data], { type: obj.fileType });
                    if (window.navigator && window.navigator.msSaveOrOpenBlob) { // for IE
                        window.navigator.msSaveOrOpenBlob(blob, fileName);
                    } else {
                        let link = document.createElement('a');
                        link.href = window.URL.createObjectURL(blob);
                        link.download = fileName;
                        link.click();
                    }
                })
        }
    },

    search: {
        run(obj) {
            return axios.post(apiRoot + 'search', obj);
        }
    },    
}